import Report from '../Common/Report'

function Renewal() {

  return <Report isRenewal={true} />

}
export default Renewal;